import {
  DollarSign,
  Wrench,
  AlertTriangle,
  Phone,
  Calendar,
} from "lucide-react";
import { useState } from "react";
import { PerformanceList } from "../performanceList/performance";
import { MonthlyStatistics } from "../monthlyStatistics/monthlyStatistics";
import { useConsumerWeeklyReport } from "../../hooks";
import { useUserName } from "@shared/selectors/globalSelectors";

export default function PerformanceLanding() {
  const cachedProfile = useUserName();

  const currentMonth = new Date().getMonth() + 1;
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const selectedYear = new Date().getFullYear();

  const months = [
    { value: 1, label: "January" + " " + selectedYear },
    { value: 2, label: "February" + " " + selectedYear },
    { value: 3, label: "March" + " " + selectedYear },
    { value: 4, label: "April" + " " + selectedYear },
    { value: 5, label: "May" + " " + selectedYear },
    { value: 6, label: "June" + " " + selectedYear },
    { value: 7, label: "July" + " " + selectedYear },
    { value: 8, label: "August" + " " + selectedYear },
    { value: 9, label: "September" + " " + selectedYear },
    { value: 10, label: "October" + " " + selectedYear },
    { value: 11, label: "November" + " " + selectedYear },
    { value: 12, label: "December" + " " + selectedYear },
  ];

  const { data: weeklyPerformance } = useConsumerWeeklyReport(cachedProfile);

  const selectedMonthLabel =
    months.find((month) => month.value === selectedMonth)?.label ||
    months[currentMonth - 1].label;



  return (
    <div className="space-y-6 p-2">
      {/* Header with inline month selector */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">My Performance</h1>
          <p className="text-muted-foreground">
            Track your monthly performance and goals.
          </p>
        </div>
     
        {/* Month Selector */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Calendar className="h-4 w-4" />
            <span>Month Filter:</span>
          </div>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(Number(e.target.value))}
            className="w-[180px] px-3 py-2 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
          >
            {months.map((month) => (
              <option key={month.value} value={month.value}>
                {month.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <MonthlyStatistics selectedMonthLabel={selectedMonthLabel} />

      <PerformanceList data={weeklyPerformance} />
    </div>
  );
}
